export default "__VITE_ASSET__1a3d85b1__"